import { useLocation } from 'react-router-dom';

import cx from 'classnames';

import { UserRoles } from '@cloud-wave/neon-common-lib';

import { useAuthContext } from 'lib/core/context/AuthProvider';

import { usePermissionsContext } from 'lib/common/contexts/PermissionsContext';

import { useHistory } from 'lib/common/hooks/useHistory';

import Icon from 'lib/common/components/Icon';
import Tooltip from 'lib/common/components/atoms/Tooltip';

import { SoftphoneNavOption } from 'lib/common/types/SoftphoneNavOption';

import './softphone-nav-menu-item.scss';

export default function SoftphoneNavMenuItem({
  permissionType,
  permission,
  link,
  icon,
  name,
  requiresRoles,
}: SoftphoneNavOption & { link: string }) {
  const location = useLocation();
  const { user } = useAuthContext();
  const { Link } = useHistory();
  const role = user?.role ?? UserRoles.AGENT;

  const { hasPermission } = usePermissionsContext();

  const satisfiesRoleRequirements = !requiresRoles || requiresRoles.includes(role);
  const showMenuItem = satisfiesRoleRequirements && hasPermission({ type: permissionType || 'tenant', permission });

  if (!showMenuItem) {
    return null;
  }

  return (
    <div
      className={cx('softphone-nav-menu-item', {
        'softphone-nav-menu-item--active': location.pathname === link,
      })}
    >
      <Tooltip title={name} aria-label={name} placement="right" enterDelay={1000} ariaHidden>
        <Link to={link}>
          <Icon icon={icon} size={18} />
        </Link>
      </Tooltip>
    </div>
  );
}
